function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M0 0h14.124v14.937H0z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#FFF",
  fillRule: "nonzero",
  width: 35,
  height: 35,
  rx: 3
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(10.085 9.492)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("path", {
  d: "M9.24 3.707c-.465-.512-1.172-.769-2.121-.769-.621 0-1.137.106-1.547.316a2.87 2.87 0 00-1.506 1.771c-.1.348-.16.66-.178.934h6.325c-.183-.989-.507-1.74-.972-2.252m-4.395 7.467c.584.568 1.424.852 2.52.852.784 0 1.46-.196 2.025-.59.566-.393.913-.81 1.04-1.249h3.423c-.548 1.702-1.387 2.92-2.519 3.65-1.132.734-2.5 1.1-4.107 1.1-1.113 0-2.117-.178-3.012-.535a6.261 6.261 0 01-2.272-1.524 6.873 6.873 0 01-1.437-2.361C.169 9.6 0 8.595 0 7.497A8.3 8.3 0 01.52 4.53 6.962 6.962 0 012 2.156 6.958 6.958 0 014.285.577C5.17.193 6.15 0 7.228 0c1.205 0 2.254.234 3.149.7a6.289 6.289 0 012.204 1.881c.575.787.99 1.684 1.246 2.691A10.05 10.05 0 0114.1 8.43H3.888c.055 1.263.374 2.178.958 2.744",
  fill: "#0C2C52",
  mask: "url(#b)"
})));

function SvgIconEflowWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEflowWhite);
export default __webpack_public_path__ + "static/media/icon-eflow-white.db961e11.svg";
export { ForwardRef as ReactComponent };